import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-live-course-faq',
  templateUrl: './live-course-faq.component.html',
  styleUrls: ['./live-course-faq.component.scss']
})
export class LiveCourseFAQComponent implements OnInit {
  topic1On: boolean = true;
  constructor() { }
  ngOnInit(): void { }
  FNQArr = [
      {
          id: 1,
          isOpened: false,
          qName: 'How can I enroll in the course?',
          qAns: 'You can register by clicking the [Register Now] button available at multiple places on this page.'
      },
      {
          id: 2,
          isOpened: false,
          qName: 'How do I access recordings of previous lectures?',
          qAns: 'You will receive your LMS credentials one week before the training begins. Once logged in, you can access all past lecture recordings from your dashboard.'
      },
      {
          id: 3,
          isOpened: false,
          qName: 'What is the duration of the course?',
          qAns: 'As per the plan shared by your college, the course duration is 6 weeks. You can find more details in the curriculum section.'
      },
      {
          id: 4,
          isOpened: false,
          qName: 'What is the mode of training?',
          qAns: 'The training will be conducted entirely online through interactive live sessions on Zoom.'
      },
      {
          id: 5,
          isOpened: false,
          qName: 'Will I receive a certification upon course completion?',
          qAns: 'Yes! You will receive a course completion certificate along with rewards upon successfully completing the course.'
      },
      {
          id: 6,
          isOpened: false,
          qName: 'Is there a minimum attendance requirement for certification?',
          qAns: 'While there is no strict attendance requirement, we strongly recommend attending all sessions for the best learning experience and outcomes.'
      },
      {
          id: 7,
          isOpened: false,
          qName: 'Who can I contact for issues or doubts regarding the course?',
          qAns: 'For any concerns or queries, please email us at info@algotutor.io or call +91-7260058093. We’ll get back to you as soon as possible.'
      },

  ]

  toggleAccordian(event, index, selectedData) {
    const element = event.target;
    element.classList.toggle("active");
    for (let i = 0; i < this.FNQArr.length; i++) {
      if (this.FNQArr[i].id == selectedData.id) {
        this.FNQArr[i].isOpened = !this.FNQArr[i].isOpened;
      } else {
        this.FNQArr[i].isOpened = false;
      }
    }

    const panel = element.nextElementSibling;
    if (panel != null) {
      if (panel?.style.maxHeight) {
        panel.style.maxHeight = null;
      } else {
        panel.style.maxHeight = panel.scrollHeight + "px";
      }
    }
  }
}
